const links = [
    {
        id: 1,
        text: 'Home',
        path: '/',
    },
    {
        id: 2,
        text: 'About Us',
        path: 'about-us',

    }, 
    {
        id: 3,
        text: 'Contact Us',
        path: 'contact-us',

    }, 
    {
        id: 4,
        text: 'User Documentation',
        path: 'user-doc',

    },
]

export default links

export const products_url = 'https://course-api.com/react-store-products'

export const single_product_url = `https://course-api.com/react-store-single-product?id=`